var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftAngle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.330273 6.70542C-0.10918 7.14487 -0.10918 7.85854 0.330273 8.298L5.95527 13.923C6.39473 14.3625 7.1084 14.3625 7.54785 13.923C7.9873 13.4835 7.9873 12.7699 7.54785 12.3304L2.71738 7.49995L7.54434 2.66948C7.98379 2.23003 7.98379 1.51636 7.54434 1.0769C7.10488 0.637451 6.39121 0.637451 5.95176 1.0769L0.326757 6.7019L0.330273 6.70542Z",
    fill: "#0A3059"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftAngle);
export default __webpack_public_path__ + "static/media/left-angle.988c39586789fa97e6322f3558a69094.svg";
export { ForwardRef as ReactComponent };